import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { Button } from "reactstrap";
import { FiEdit } from "react-icons/fi";
import { TiUserDelete } from "react-icons/ti";
import apiService from "services/api";
import { CustomAlert, CustomTable } from "components";
import { useNotificationContext } from "contexts";
import { membershipColumns } from "./constants";

const ParentsPage = () => {
	const { data, isLoading, refetch } = useQuery("parent", () => apiService.parent.get());

	const { createNotification } = useNotificationContext();
	const [memberToDelete, setMemberToDelete] = useState({
		firstName: "",
		lastName: "",
		id: "",
	});

	const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);

	const showDeleteModal = (memberToDelete) => {
		setMemberToDelete(memberToDelete);
		setDisplayConfirmationModal(true);
	};

	// Hide the modal
	const hideConfirmationModal = () => {
		setDisplayConfirmationModal(false);
	};

	// Handle the actual deletion of the item
	const submitDelete = async () => {
		await apiService.parent
			.delete(memberToDelete.id)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully deleted member",
				});
				refetch();
			})
			.catch((error) => createNotification({ type: "danger", message: error.message }));

		setDisplayConfirmationModal(false);
	};

	const actions = (row) => (
		<div className="actions-right">
			<Link to={`/parent/edit/${row.id}`}>
				<Button color="warning" size="sm" className="btn-icon btn-link edit">
					<FiEdit size={20} />
				</Button>
			</Link>
			{/* todo, delete parent and validation */}
			{/* <Link to={`/parent/delete/${row.id}`}> */}
			<Button color="warning" size="sm" className="btn-icon btn-link edit" onClick={() => showDeleteModal(row)}>
				<TiUserDelete className="text-danger" size={20} />
			</Button>
			{/* </Link> */}
		</div>
	);

	return (
		<div className="content">
			<div className="mt-3">
				<div className="d-flex mb-2">
					<Link to={`/parent/new`}>
						<button type="button" className="btn btn-info">
							Add new member
						</button>
					</Link>
				</div>

				<CustomAlert
					title="Remove Member"
					show={displayConfirmationModal}
					hideModal={hideConfirmationModal}
					description={
						<>
							Are you sure you want to remove member{" "}
							<span className="text-danger font-weight-bold">
								{memberToDelete.firstName} {memberToDelete.lastName}?
							</span>
						</>
					}
					submitModal={submitDelete}
					submitButtonText="Delete"
				/>

				<CustomTable data={data} columns={membershipColumns} defaultPageSize={25} title="Members" actions={actions} loading={isLoading} />
			</div>
		</div>
	);
};

export default ParentsPage;
